module.exports = __webpack_public_path__ + "media/images/category-food-32be9940bf610e16a472f07d9d9d4c02.jpg";